module.exports = __webpack_public_path__ + "media/components/app-store/static/s1-d535e26a7df11063c25855e34612f0cd.jpg";